<div class="table-container">
  <table class="table">
    <thead *ngIf="headerTemplate" class="table-header">
      <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
    </thead>
    <tbody *ngIf="!loading && data.length > 0">
      <ng-container *ngFor="let item of data">
        <ng-container [ngTemplateOutlet]="rowTemplate" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
      </ng-container>
    </tbody>
    <tbody *ngIf="!loading && data.length === 0">
      <tr>
        <td colspan="100%" class="p-4 text-center">
          <ng-container *ngIf="emptyTemplate; else defaultEmpty">
            <ng-container [ngTemplateOutlet]="emptyTemplate"></ng-container>
          </ng-container>
          <ng-template #defaultEmpty>
            <p class="text-gray-500 dark:text-gray-400">No data available</p>
          </ng-template>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="loading">
      <tr>
        <td colspan="100%" class="p-4 text-center">
          <div class="flex justify-center">
            <svg class="animate-spin h-8 w-8 text-primary-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div> 